import type {ReactNode} from "react";
import {cn} from "@/lib/utils";

/** Kept for call-site compatibility; breadcrumbs render in AdminShell topbar only. */
export type AdminBreadcrumbItem = {
  label: string;
  href?: string;
};

type Props = {
  title: string;
  description?: string;
  /** Ignored — topbar owns breadcrumbs to avoid duplicates. */
  breadcrumbs?: AdminBreadcrumbItem[];
  actions?: ReactNode;
  className?: string;
};

export function AdminPageHeader({title, description, actions, className}: Props) {
  // Breadcrumbs live in AdminShell topbar only — do not duplicate above the title.
  return (
    <header className={cn("admin-page__header admin-page-header", className)}>
      <div className="admin-page-header__row">
        <div className="min-w-0 space-y-1.5">
          <h1 className="admin-h1">{title}</h1>
          {description ? <p className="admin-subtitle max-w-2xl">{description}</p> : null}
        </div>
        {actions ? <div className="admin-page-header__actions">{actions}</div> : null}
      </div>
    </header>
  );
}
